var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "tm-footer" }, [
    _c("img", {
      staticClass: "position-absolute t-n1 rotate-180",
      attrs: {
        src: require("@/assets/grey-wave.svg"),
        alt: "",
        "aria-hidden": "true"
      }
    }),
    _c("img", {
      staticClass: "tm-footer__logo",
      attrs: { src: require("@/assets/logo-white.svg"), alt: "tamsin.io" }
    }),
    _vm._m(0),
    _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("ul", { staticClass: "d-inline-block px-4" }, [
        _c("li", [
          _c("span", { staticClass: "tm-footer__list-title" }, [
            _vm._v("Navigation")
          ]),
          _c("ul", [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  { staticClass: "tm-footer__link", attrs: { to: "/" } },
                  [_vm._v("Home")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  { staticClass: "tm-footer__link", attrs: { to: "/guide" } },
                  [_vm._v("Guide")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  { staticClass: "tm-footer__link", attrs: { to: "/careers" } },
                  [_vm._v("Careers")]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c("ul", { staticClass: "d-inline-block px-4" }, [
        _c("li", [
          _c("span", { staticClass: "tm-footer__list-title" }, [
            _vm._v("Follow Us")
          ]),
          _c("ul", { staticClass: "d-flex" }, [
            _c(
              "li",
              { staticClass: "mr-3" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "tm-footer__link",
                    attrs: { to: "/", "aria-label": "Follow us on Instagram" }
                  },
                  [_c("i", { staticClass: "fab fa-instagram" })]
                )
              ],
              1
            ),
            _c(
              "li",
              { staticClass: "mr-3" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "tm-footer__link",
                    attrs: { to: "/", "aria-label": "Follow us on Twitter" }
                  },
                  [_c("i", { staticClass: "fab fa-twitter" })]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "tm-footer__link",
                    attrs: { to: "/", "aria-label": "Follow us on Facebook" }
                  },
                  [_c("i", { staticClass: "fab fa-facebook" })]
                )
              ],
              1
            )
          ])
        ])
      ])
    ]),
    _c("span", { staticClass: "py-3" }, [_vm._v("Dylan Davies ©2020")])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tm-footer__search my-4" }, [
      _c(
        "i",
        {
          staticClass: "tm-footer__search__icon material-icons-round",
          attrs: { "aria-hidden": "true" }
        },
        [_vm._v("search")]
      ),
      _c("input", {
        attrs: { "aria-label": "Search", placeholder: "Search..." }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }